// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.cleaning_field_kind_enum */
var CleaningFieldKindEnum;
(function (CleaningFieldKindEnum) {
    CleaningFieldKindEnum["NUMBER"] = "NUMBER";
    CleaningFieldKindEnum["TEXT"] = "TEXT";
    CleaningFieldKindEnum["CHECKBOX"] = "CHECKBOX";
    CleaningFieldKindEnum["DATETIME"] = "DATETIME";
    CleaningFieldKindEnum["DATE"] = "DATE";
    CleaningFieldKindEnum["INVENTORY_ITEM"] = "INVENTORY_ITEM";
    CleaningFieldKindEnum["COMPUTED"] = "COMPUTED";
})(CleaningFieldKindEnum || (CleaningFieldKindEnum = {}));
;
export default CleaningFieldKindEnum;
/** Zod schema for cleaning_field_kind_enum */
export const cleaningFieldKindEnum = z.nativeEnum(CleaningFieldKindEnum);
//# sourceMappingURL=CleaningFieldKindEnum.js.map